export const PinChangeType = {
  ACTIVATION: 'ACTIVATION',
};

//CONTINUE_REGISTRATION



// WEBPACK FOOTER //
// ./components/transaction/src/utils/changePinSource.js